$(function () { 

	var ofiImages = $('.ofi-cover');
	objectFitImages(ofiImages);

});